// One login, more services as roles are added. The account area is built
// from servicesFor(); the Worker checks the same function on every call.

export type Role = "downloader" | "customer" | "tester" | "school" | "reseller";
export type OrgRole = "admin" | "member";

export const SERVICES = {
  download_iso: "Download the ISO",
  feedback: "Send feedback and read replies",
  register_devices: "Register devices with activation codes",
  support: "Warranty and support tickets",
  fleet_view: "Fleet view of your devices",
  testers_channel: "The testers channel and early builds",
  offline_bundles: "Signed offline bundles",
  preload_images: "Preload images and bulk activation codes",
  invite_members: "Invite colleagues",
  billing: "Invoices and API keys",
} as const;
export type Service = keyof typeof SERVICES;

export const GRANTS: Record<Role, Service[]> = {
  downloader: ["download_iso", "feedback"],
  customer: ["register_devices", "support", "fleet_view", "billing"],
  tester: ["register_devices", "fleet_view", "testers_channel"],
  school: ["register_devices", "support", "fleet_view", "offline_bundles", "billing"],
  reseller: ["register_devices", "support", "fleet_view", "offline_bundles", "preload_images", "billing"],
};

export interface Membership { kind: "school" | "reseller"; role: OrgRole; status: "pending" | "approved" | "rejected" | "blocked" }

export function rolesFor(personal: ("customer" | "tester")[], memberships: Membership[]): Role[] {
  const roles = new Set<Role>(["downloader", ...personal]);
  for (const m of memberships) if (m.status === "approved") roles.add(m.kind);
  return [...roles];
}

export function servicesFor(personal: ("customer" | "tester")[], memberships: Membership[]): Service[] {
  const out = new Set<Service>();
  for (const r of rolesFor(personal, memberships)) for (const s of GRANTS[r]) out.add(s);
  if (memberships.some((m) => m.status === "approved" && m.role === "admin")) out.add("invite_members");
  return [...out];
}
